var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacau(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0f7562",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffde23",
    d: "M11.12 6.15a.1.1 0 0 1 .04-.1.1.1 0 0 1 .12 0l.47.35.48-.34a.1.1 0 0 1 .16.11l-.2.56.47.36a.1.1 0 0 1 0 .16l-.05.02-.6-.01-.19.56a.1.1 0 0 1-.19 0l-.17-.57-.6-.01a.1.1 0 0 1-.05-.18l.48-.34zM9.87 8.18a.1.1 0 0 1 .19.02l.11.58.59.07a.1.1 0 0 1 .04.19l-.52.28.11.58a.1.1 0 0 1-.1.12l-.06-.02-.44-.4-.51.28a.1.1 0 0 1-.14-.13l.25-.54-.43-.4a.1.1 0 0 1 .07-.17l.6.07zm8.85-2.14a.1.1 0 0 1 .16.11l-.17.57.48.34a.1.1 0 0 1 .04.1.1.1 0 0 1-.1.08h-.59l-.17.57a.1.1 0 0 1-.1.07.1.1 0 0 1-.09-.06l-.2-.56h-.58a.1.1 0 0 1-.07-.17l.48-.36-.2-.55a.1.1 0 0 1 .1-.14l.05.02.5.34zm1.22 2.16a.1.1 0 0 1 .19-.02l.25.53.58-.07a.1.1 0 0 1 .09.17l-.44.4.25.54a.1.1 0 0 1-.02.11.1.1 0 0 1-.11.02l-.52-.29-.44.4a.1.1 0 0 1-.16-.08l.11-.59-.52-.28a.1.1 0 0 1-.02-.16l.06-.03.59-.07zM15 4.53l.3.9h.95l-.77.57.3.91-.78-.56-.78.56.3-.91-.77-.56h.95z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffde23",
    d: "M14.9 4.5a.1.1 0 0 1 .2 0l.27.84h.88a.1.1 0 0 1 .07.18l-.72.52.27.84a.1.1 0 0 1-.04.11.1.1 0 0 1-.11 0L15 6.47l-.72.52a.1.1 0 0 1-.15-.05v-.06l.27-.84-.71-.52a.1.1 0 0 1 .05-.18h.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.7 17.75a.25.25 0 1 1 0 .5h-3.5a.25.25 0 1 1 0-.5zm2.25-1a.25.25 0 1 1 0 .5h-8a.25.25 0 1 1 0-.5zm1.25-1a.25.25 0 1 1 0 .5H9.7a.25.25 0 1 1 0-.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M14.95 8c.74.52 1.25 1.65 1.25 2.97q0 .75-.2 1.4.71-.35 1.48-.48c1.42-.25 2.73.04 3.42.66-.43.83-1.57 1.55-2.98 1.8a4.7 4.7 0 0 1-2.97-.35c-.73.4-1.81.56-2.97.35a4.4 4.4 0 0 1-2.9-1.65L9 12.56l.13-.1c.67-.53 1.8-.77 3.04-.6l.25.03a6 6 0 0 1 1.49.48 5 5 0 0 1-.21-1.4c0-1.32.51-2.45 1.25-2.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacau);
export default __webpack_public_path__ + "static/media/macau.99f10705cf73ac42da7e6f572dd5391e.svg";
export { ForwardRef as ReactComponent };